export var EWorkshopPublicPolicy;
(function (EWorkshopPublicPolicy) {
    EWorkshopPublicPolicy["viewer"] = "viewer";
    EWorkshopPublicPolicy["contributor"] = "contributor";
})(EWorkshopPublicPolicy || (EWorkshopPublicPolicy = {}));
//# sourceMappingURL=workshop.js.map